<template>
	<div>
		<div class="d-flex justify-space-between align-center mb-2 mt-6">
			<div class="input-wrap">
				<h5 class="mb-2">Categorías</h5>
			</div>
			<div class="action-btn-wrap">
				<v-btn color="accent" @click.prevent="clickCreate()">Nuevo</v-btn>
			</div>
		</div>
		<v-card color="secondary" class="pa-3">
			<emb-data-table :resource="resource" :columns="columns">
				<tr slot="heading">
					<th>N°</th>
					<th>NOMBRE</th>
					<th>DELIVERY</th>
					<th class="text-right">ACCIONES</th>
				</tr>
				<tr slot-scope="{ index, row }" :key="index">
					<td>{{ index }}</td>
					<td>{{ row.name }}</td>
					<td>{{ row.delivery ? 'Si' : 'No' }}</td>
					<td class="text-right">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn
									color="secondary"
									class="ma-1"
									fab
									x-small
									dark
									@click.prevent="clickCreate(row.id)"
									v-on="on"
								>
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Modificar</span>
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn
									color="accent"
									class="ma-1"
									fab
									x-small
									dark
									@click.prevent="clickDelete(row.id)"
									v-on="on"
								>
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Eliminar</span>
						</v-tooltip>
					</td>
				</tr>
			</emb-data-table>
		</v-card>

		<category-form
			:showDialog.sync="showDialog"
			:recordId="recordId"
			:external="false"
		></category-form>
	</div>
</template>

<script>
import { deletable } from 'Mixins/deletable';
import CategoryForm from './Form.vue';

export default {
	data() {
		return {
			showDialog: false,
			resource: 'categories',
			recordId: null,
			records: [],
			columns: {
				name: 'Nombre',
			},
		};
	},
	mixins: [deletable],
	components: {
		CategoryForm,
	},
	methods: {
		clickCreate(recordId = null) {
			this.recordId = recordId;
			this.showDialog = true;
		},
		clickDelete(id) {
			this.destroy(`/${this.resource}/${id}`).then(() =>
				this.$eventHub.$emit('reloadData', this.resource)
			);
		},
	},
};
</script>
